
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ArchitecturalProjectsSection from './components/ArchitecturalProjectsSection';
import TechnicalProjectsSection from './components/TechnicalProjectsSection';
import RegularizationSection from './components/RegularizationSection';
import ConstructionManagementSection from './components/ConstructionManagementSection';
import EventLicensesSection from './components/EventLicensesSection';
import WhyChooseSection from './components/WhyChooseSection';

export default function ServicesPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <IntroSection />
        <ArchitecturalProjectsSection />
        <TechnicalProjectsSection />
        <RegularizationSection />
        <ConstructionManagementSection />
        <EventLicensesSection />
        <WhyChooseSection />
      </main>
      <Footer />
    </div>
  );
}
